import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';

export const StyledBox = styled(Box)(({ theme }) => ({
  marginBlockStart: theme.spacing(5),
  display: 'inline-block',
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.utility.gray50,
  color: theme.palette.utility.gray800,
  border: `1px solid ${theme.palette.utility.gray200}!important`,
  minWidth: theme.spacing(7),
  borderRadius: theme.shape.borderRadius * 1.5,
  minHeight: theme.spacing(7),
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  height: theme.spacing(9.5),
  padding: `${theme.spacing(2.25, 3)}!important`,
}));
